module.exports = __webpack_public_path__ + "static/media/Left.76d6d480.png";